/* eslint-disable react/destructuring-assignment */
import React, { startTransition, useEffect, useState } from 'react';

import type { FC } from 'react';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';

import { InstallmentCalculatorDialog } from '@packages/installment-calculator';
import { Layout1 } from '../Layout1';
import { Layout2 } from '../Layout2';
import { Layout3 } from '../Layout3';
import { useInstallmentCalculatorTracking } from '../../../Tracking/hooks/useInstallmentCalculatorTracking';

export type InstallmentCalulatorInDialogProps = {
  /**
   * the single installment value from the calculation result as integer (e.g. 1337)
   */
  singleInstallment: number;
  /**
   * the currency string from the calculation result
   */
  currency: string;
  /**
   * the number of installments from the calculation result
   */
  numberOfInstallments: number;
  /**
   * Product price value as int (e.g. 1337)
   */
  basePrice: number;
};

export const InstallmentCalulatorInDialog: FC<InstallmentCalulatorInDialogProps> = ({
  singleInstallment,
  currency,
  numberOfInstallments,
  basePrice,
}) => {
  const [dialogOpened, setDialogOpened] = useState(false);
  const {
    installmentCalculator: { InstallmentCalculatorCallToActionLayout },
  } = useConfig();

  const { trackGlycerinDisplayLink } = useInstallmentCalculatorTracking();

  useEffect(() => {
    trackGlycerinDisplayLink();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <InstallmentCalculatorDialog
        basePrice={basePrice}
        open={dialogOpened}
        handleClose={() => startTransition(() => setDialogOpened(false))}
        displayTrackingProps={{ category: 'Ratenrechner', label: 'Kredit-Promo' }}
      />

      {InstallmentCalculatorCallToActionLayout?.layout === 'Layout1' && (
        <Layout1
          singleInstallment={singleInstallment}
          currency={currency}
          numberOfInstallments={numberOfInstallments}
          openInstallmentCalulatorHandler={() => startTransition(() => setDialogOpened(true))}
        />
      )}
      {InstallmentCalculatorCallToActionLayout?.layout === 'Layout2' && (
        <Layout2
          singleInstallment={singleInstallment}
          currency={currency}
          numberOfInstallments={numberOfInstallments}
          openInstallmentCalulatorHandler={() => startTransition(() => setDialogOpened(true))}
        />
      )}
      {InstallmentCalculatorCallToActionLayout?.layout === 'Layout3' && (
        <Layout3
          singleInstallment={singleInstallment}
          currency={currency}
          openInstallmentCalulatorHandler={() => startTransition(() => setDialogOpened(true))}
        />
      )}
    </>
  );
};
